import { useState, useEffect } from 'react';
import { UserHttpService } from 'core/services/user';

const useCertificationForm = (id) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        const loadCertification = async () => {
            if (!id) return;
            
            setIsLoading(true);
            setError(null);
            
            try {
                const response = await UserHttpService.getCertification(id);
                setData(response.data);
            } catch (err) {
                setError(err.message || 'Failed to load certification');
            } finally {
                setIsLoading(false);
            }
        };

        loadCertification();
    }, [id]);

    const saveCertification = async (formData) => {
        setIsLoading(true);
        setError(null);

        try {
            if (id) {
                await UserHttpService.updateCertification(id, formData);
            } else {
                await UserHttpService.createCertification(formData);
            }
        } catch (err) {
            setError(err.message || 'Failed to save certification');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        error,
        data,
        saveCertification
    };
};

export default useCertificationForm; 